import Multilingual from '~~utils/Multilingual';

const localMapping = {
  CUSTOM: {
    REGISTRY_PANEL: {
      'zh-TW': '我的報名資料',
      en: 'My Registry Info',
    },
    TABLE: {
      TOURNAMENT: {
        'zh-TW': '報名賽事',
        en: 'Tournament',
      },
      TEAM: {
        'zh-TW': '報名球隊',
        en: 'My Team',
      },
      HISTORY_CONNECTION: {
        'zh-TW': '歷史資料連結',
        en: 'History Connection',
      },
      STATUS: {
        'zh-TW': '狀態',
        en: 'Status',
      },
      UPDATED_AT: {
        'zh-TW': '更新時間',
        en: 'Updated At',
      },
      ACTION: {
        WORDING: {
          'zh-TW': '操作',
          en: 'Action',
        },
        MANAGE: {
          'zh-TW': '管理',
          en: 'Manage',
        },
      },
    },
    STATUS: {
      SIGNED_UP: {
        'zh-TW': '資料準備',
        en: 'Data Prepare',
      },
      REVIEW_REQUESTED: {
        'zh-TW': '審核中',
        en: 'Pending Review',
      },
      REVIEW_COMPLETED: {
        'zh-TW': '審核完成（待繳費）',
        en: 'Review Completed(Payment Required)',
      },
      PAYMENT_CHECK_REQUESTED: {
        'zh-TW': '已繳費待確認',
        en: 'Pending Payment Confirm',
      },
      COMPLETED: {
        'zh-TW': '完成報名',
        en: 'Completed',
      },
    },
    TEAM_SIDEBAR: {
      OVERVIEW: {
        'zh-TW': '概覽',
        en: 'Overview',
      },

      STEP_ONE_SIGNED_UP: {
        'zh-TW': '1. 資料準備',
        en: '1. Data Prepare',
      },
      TEAM: {
        'zh-TW': '球隊',
        en: 'Team',
      },
      STAFF: {
        'zh-TW': '隨隊人員',
        en: 'Staff',
      },
      PLAYER: {
        'zh-TW': '球員',
        en: 'Player',
      },
      PDF: {
        'zh-TW': '文件上傳',
        en: 'Doc Upload',
      },

      STEP_TWO_REVIEW: {
        'zh-TW': '2. 資料審核',
        en: '2. Data Review',
      },
      REVIEW_STATUS: {
        'zh-TW': '審核進度',
        en: 'Review Status',
      },

      STEP_THREE_PAYMENT: {
        'zh-TW': '3. 費用繳交',
        en: '3. Payment',
      },
      PAYMENT_STATUS: {
        'zh-TW': '繳費狀況',
        en: 'Payment Status',
      },
    },
    HISTORY_CONNECTION_CITY_ICON_HINT: {
      'zh-TW': '歷史資料連結，縣市與隊徽已與球隊管理連動。（仍可依照需求調整隊名）',
      en: 'History Connection, City and Icon have linked with team. Avaliable to change team name depends on demand.',
    },
    REGISTRY_INFO: {
      'zh-TW': '報名資訊',
      en: '報名資訊',
    },
    TEAM_PDF: {
      'zh-TW': '球隊文件',
      en: 'Team Document',
    },
    STAFF_PDF: {
      'zh-TW': '隨隊文件',
      en: 'Staff Document',
    },
    PLAYER_PDF: {
      'zh-TW': '球員文件',
      en: 'Player Document',
    },
    REVIEW: {
      COMPLETION_CHECK: {
        'zh-TW': '資料完整度檢查',
        en: 'Data Completion Check',
      },
      RESULT_NOT_COMPLETED: {
        'zh-TW': '不完整',
        en: 'Not Completed',
      },
      COMPLETED: {
        'zh-TW': '資料完整',
        en: 'Data Completed',
      },
      MISSING: {
        'zh-TW': '資料缺漏',
        en: 'Data Missing',
      },

      SEND_REVIEW_REQUESTED: {
        'zh-TW': '送出審核申請',
        en: 'Send Review Request',
      },
      SEND_REVIEW_REQUESTED_DESCRIPTION: {
        'zh-TW': '審核中將無法更改資料',
        en: 'It will be uneditable when pending review',
      },

      SEND_PAYMENT_CHECK_REQUESTED: {
        'zh-TW': '送出繳費確認申請',
        en: 'Send Payment Check Request',
      },

      REVOKE: {
        'zh-TW': '撤銷申請',
        en: 'Revoke',
      },

      SENT: {
        'zh-TW': '已送出，請等候主辦方通知',
        en: 'Sent, please wait manager for next action',
      },
    },
  },
};

const multi = (textCode, lang = '') => {
  return Multilingual(textCode, localMapping, lang);
};
export default multi;
